'use client';

import { useEffect, useState } from 'react';

export function useMediaQuery(query: string, defaultValue: boolean = false): boolean {
    const [isMatches, setIsMatches] = useState(defaultValue);

    useEffect(() => {
        const media = window.matchMedia(query);

        // Set initial value
        setIsMatches(media.matches);

        // Listen for changes
        const listener = (event: MediaQueryListEvent) => {
            setIsMatches(event.matches);
        };

        media.addEventListener('change', listener);

        return () => {
            media.removeEventListener('change', listener);
        };
    }, [query]);

    return isMatches;
}
